<table-list [resource]="skinResource" [service]="skinService"></table-list>
